/* eslint-disable max-len */
import React from 'react';

const CheckboxIndeterminateIcon = () => (
  <svg
    viewBox="0 0 24 24"
    height="24"
    width="24"
    focusable="false"
    aria-hidden="true"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="none"></rect>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 10H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"></path>
  </svg>
);

export default CheckboxIndeterminateIcon;
